import type { ReactElement } from 'react'
import React, { useState } from 'react'

import { Dropdown, Icon } from '@fourthwall/components'
import { ArrowShortDownIcon, ArrowShortUpIcon } from '@fourthwall/icons'

import type { ThankYouMediaSource } from '../../SendThankYouModal.types'
import * as S from './MediaSourceButton.styled'

type MediaSourceButtonProps = {
  options: ThankYouMediaSource[]
  icon: ReactElement
  onChange?: (id: string) => void
}

export const MediaSourceButton = ({ options, icon, onChange }: MediaSourceButtonProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleItemClick = (id: string) => {
    onChange?.(id)
    setIsOpen(false)
  }

  return (
    <Dropdown
      maxWidth={480}
      isOpen={isOpen}
      content={options.map((item) => (
        <Dropdown.Item
          key={item.id}
          label={item.label}
          active={!!item.active}
          onClick={() => handleItemClick(item.id)}
        />
      ))}
      onClose={() => setIsOpen(false)}
    >
      <S.Container isOpen={isOpen} onClick={() => setIsOpen(true)}>
        {icon} <Icon component={isOpen ? ArrowShortUpIcon : ArrowShortDownIcon} height={8} />
      </S.Container>
    </Dropdown>
  )
}
